import React, { Component } from 'react';
import ReactDOM, { render } from 'react-dom';
import { stepStore } from '../../mobx/stores/step';
import './index.scss';

class SwitchPopup extends Component {
  constructor(props) {
    super(props);
    this.state = {
      visible: true
    };

    this.hide = this.hide.bind(this);
    this.onSwitch = this.onSwitch.bind(this);
  }

  onSwitch(mode) {
    if (mode === this.props.defaultMode) return;
    stepStore.mode = mode;
    this.hide();
  }

  hide() {
    this.setState({
      visible: false
    });
  }

  render() {
    const { defaultMode, modes } = this.props;
    return (
      <div className={['switch-popup', `switch-popup-${this.state.visible ? 'show' : 'hidden'}`].join(' ')}>
        <div className="mask" onClick={this.hide}></div>
        <div className="switch-aside">
          {
            modes.map((item) => {
              return (
                <a
                  key={item.name}
                  className={['switch-item', defaultMode === item.value ? 'switch-item-active' : ''].join(' ')}
                  onClick={() => this.onSwitch(item.value)}
                >
                  {item.name}
                </a>
              );
            })
          }
        </div>
      </div>
    );
  }
}

const modes = [
  {
    name: '一般模式',
    value: 'normal'
  },
  {
    name: '自动模式',
    value: 'automatic'
  },
  {
    name: '专家模式',
    value: 'expert'
  }
];

export default {
  showSwitchPopup(defaultMode) {
    const div = document.createElement('div');
    document.body.appendChild(div);
    render(
      <SwitchPopup defaultMode={defaultMode} modes={modes} />,
      div
    );

    return {
      destroy() {
        ReactDOM.unmountComponentAtNode(div);
      }
    };
  }
};
